export default __webpack_public_path__ + "static/media/CaegisLogo.bc78c153.png";